import React from 'react';
import { TextLarge, TextRegular, TextSmall } from '@hz-design-system/web-ui';
import Classes from './ListingDate.module.scss';

interface ListingDateProps {
  date: string;
}

interface ListingDateComponentProps {
  Large: React.FC<ListingDateProps>;
  Small: React.FC<ListingDateProps>;
  Regular: React.FC<ListingDateProps>;
}

const ListingDateLarge: React.FC<ListingDateProps> = ({ date }) => {
  return <TextLarge className={Classes['hz-Listing-date']}>{date}</TextLarge>;
};

const ListingDateSmall: React.FC<ListingDateProps> = ({ date }) => {
  return <TextSmall className={Classes['hz-Listing-date']}>{date}</TextSmall>;
};

const ListingDateRegular: React.FC<ListingDateProps> = ({ date }) => {
  return <TextRegular className={Classes['hz-Listing-date']}>{date}</TextRegular>;
};

const ListingDate: ListingDateComponentProps = {
  Large: ListingDateLarge,
  Regular: ListingDateRegular,
  Small: ListingDateSmall,
};

export default ListingDate;
